var submitCart = {
    deleteOpenPrompt: function () {
        notification.confirm(
            output.t_sind_sie_sicher_dass_sie_diese_positionen_loeschen_wollen,
            submitCart.deleteOpenCarts
        );
        return false;
    },
    deleteOpenCarts: function (btn, text) {
        if (btn == 'yes' || btn) {
            if ($('#DeleteAllOpenCarts').attr('checked') == 'checked') {
                $(".cartSelect").removeAttr("disabled");
            }
            document.simulatecartform.deletesimulatedcarts.value = 'Y';
            document.simulatecartform.artlistaction.value = 'showsimulate';
            document.simulatecartform.submit();
        }
        return false;
    },
    deleteSimulatedCarts: function (confirmText, cartId) {
        notification.confirm(confirmText, function () {
            document.simulatecartform.deletesimulatedcart.value = 'Y';
            document.simulatecartform.deletesimulatedcartid.value = cartId;
            document.simulatecartform.artlistaction.value = 'showsimulate';
            document.simulatecartform.submit();
        });
        return false;
    },
    printView: function (cartId) {
        window.open('printcart.phtml?sid=' + sid + '&printcartid=' + cartId)
    },
    loadCart: function (cartId) {
        showConfirm(cartId, false, true, false)
    },
    toggle: function (cartId, toggle) {
        if (toggle == "hide") {
            $('#cart-' + cartId + ' .cartData').slideUp()
        } else {
            $('#cart-' + cartId + ' .cartData').slideDown()
        }

        $('#cart-' + cartId + ' .collapseCircle').toggleClass('hidden');
        $('#cart-' + cartId + ' .expandCircle').toggleClass('hidden')
    },
    checkDynamicApprovals: function () {
        var error = false;

        if (document.simulatecartform) {
            var _form = document.simulatecartform;

            for (var i = 0; i < _form.length; i++) {
                if (_form[i].name.indexOf("simulate_location_approval_") == 0 && _form[i].name.indexOf("comment") == -1 && _form[i].name.indexOf("checkbox") == -1) {
                    var _elem = _form[i];

                    if (_elem.disabled) {
                        continue;
                    }

                    var _parts = _elem.name.split("_");

                    if (_parts.length >= 5) {
                        var _cart_chkbox = document.getElementsByName('simulate_checkbox_' + _parts[3])[0];

                        if (_cart_chkbox && _cart_chkbox.checked == true) {

                            if (document.getElementsByName('simulate_location_approval_checkbox_' + _parts[3] + '_' + _parts[4] + '_' + _parts[5])) {
                                _elem_chkbox = document.getElementsByName('simulate_location_approval_checkbox_' + _parts[3] + '_' + _parts[4] + '_' + _parts[5])[0];
                            }

                            if (!_elem_chkbox || (_elem_chkbox && _elem_chkbox.checked == true)) {
                                if (parseInt(_parts[5]) >= 1 && (_elem.value == "" || _elem.value == "0")) {
                                    error = true;
                                    break;
                                }
                            } else {
                                /* alert(_elem.name + ' fuck ' + !_elem_chkbox + ' ' + _elem_chkbox.checked); */
                                error = true;
                                break;
                            }

                            var _eag_spotbuy_radio = document.getElementsByName('simulate_spotbuy_radio_' + _parts[3]);
                            if (_eag_spotbuy_radio && _eag_spotbuy_radio[0] && _eag_spotbuy_radio[1]) {
                                if (_eag_spotbuy_radio[0].checked == false && _eag_spotbuy_radio[1].checked == false) {
                                    error = true;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

        if (error)
            return false;

        return true;
    },
    fileTypeOk: function (uploadfile, fileTypes, errorMsg) {
        allowSubmit = false;

        if (fileTypes.length < 1) return true;
        if (!uploadfile) return false;

        while (uploadfile.indexOf("\\") != -1) {
            uploadfile = uploadfile.slice(uploadfile.indexOf("\\") + 1);
        }

        ext = uploadfile.slice(uploadfile.indexOf(".")).toLowerCase();

        for (var i = 0; i < fileTypes; i++) {
            if (fileTypes[i] == ext) {
                allowSubmit = true;
                break;
            }
        }

        if (!allowSubmit)
            notification.error(errorMsg + (fileTypes.join(", ")));

        return allowSubmit;
    },
    uploadFile: function (artId) {
        debugger;
        if (document.cartform['new_attachment' + artId].value == '')
            return notification.error(output.e_upload_file_not_chosen);

        const handler = function (internalOnly) {

            if (internalOnly) {
                $("input[name=internal_only" + artId + "]").prop('checked', true)
            }
            document.cartform.saveuploadattachment.value = 'Y';
            document.cartform.attachmentuploadcartarticleid.value = artId;
            document.cartform.artlistaction.value = '';
            submitFormGreyOut(document.cartform);
        };

        if (document.cartform['internal_only' + artId]) {
            notification.confirm(output.t_freetext_attachment_upload_internal_only, handler, handler)
        } else {
            handler(false);
        }
        return false;
    }
}
